<script setup lang="ts">
import { RouterLink } from 'vue-router'
import { config } from '@core/config'
import { ADMIN_LEGAL_FOOTER_LINKS } from '@modules/help'
import Box from '@uiKit/elements/Box.vue'
import Text from '@uiKit/elements/Text.vue'

const currentYear = new Date().getFullYear()
</script>

<template>
  <Box is="footer" flex align="center" justify="between" class="app-footer">
    <Text is="span" type="caption" class="footer-note"
      >© {{ currentYear }} Sliceal. All rights reserved.</Text
    >

    <!-- Legal links + build version read as one right-aligned cluster (per design).
         These stay in-tab: they open the Legal & Compliance CMS inside the shell,
         not an external document. Keyed by label — both share one destination. -->
    <Box is="nav" flex align="center" gap="3" aria-label="Legal links">
      <RouterLink
        v-for="link in ADMIN_LEGAL_FOOTER_LINKS"
        :key="link.label"
        :to="link.to"
        class="footer-link"
      >
        <Text is="span" type="caption">{{ link.label }}</Text>
      </RouterLink>

      <Text is="span" type="caption" class="footer-note">v {{ config.app.version }}</Text>
    </Box>
  </Box>
</template>

<style scoped>
.app-footer {
  flex-shrink: 0;
  height: 2rem;
  padding: 0 1.5rem;
  border-top: 1px solid var(--p-content-border-color);
  background: var(--p-surface-0);
}

/* Footer chrome is deliberately de-emphasised. Softening with `opacity` rather
   than a lighter hex keeps the muted text token correct in dark mode too. */
.footer-note,
.footer-link {
  opacity: 0.55;
}

.footer-link {
  text-decoration: none;
  transition: opacity 0.15s ease;
}

.footer-link:hover {
  opacity: 1;
}
</style>
